import { SimpleGrid } from "@chakra-ui/react";
import {
    Users,
    Truck,
    TrendingUp,
    RefreshCcw,
} from "lucide-react";

import StatCard from "../../Dashboard/components/StatCard";

const AnalyticsStats = ({
    drivers = [],
    milestones = [],
}) => {
    const totalReferrals =
        drivers.length;

    const activeDrivers =
        drivers.filter(
            driver =>
                driver.driver
                    ?.status ===
                "Approved"
        ).length;

    const firstDeliveryDrivers =
        new Set(
            milestones
                .filter(
                    milestone =>
                        milestone.milestone_type ===
                            "First Delivery Completed" &&
                        milestone.milestone_status ===
                            "Achieved"
                )
                .map(
                    milestone =>
                        milestone.driver_id
                )
        ).size;

    const conversionRate =
        totalReferrals > 0
            ? Math.round(
                  (
                      activeDrivers /
                      totalReferrals
                  ) * 100
              )
            : 0;

    const retentionRate =
        activeDrivers > 0
            ? Math.round(
                  (
                      firstDeliveryDrivers /
                      activeDrivers
                  ) * 100
              )
            : 0;

    const currentMonth =
        new Date().getMonth();

    const currentYear =
        new Date().getFullYear();

    const lastMonth =
        currentMonth === 0
            ? 11
            : currentMonth - 1;

    const lastMonthYear =
        currentMonth === 0
            ? currentYear - 1
            : currentYear;

    const currentMonthReferrals =
        drivers.filter(
            driver => {
                const date =
                    new Date(
                        driver.created_at
                    );

                return (
                    date.getMonth() ===
                        currentMonth &&
                    date.getFullYear() ===
                        currentYear
                );
            }
        ).length;

    const lastMonthReferrals =
        drivers.filter(
            driver => {
                const date =
                    new Date(
                        driver.created_at
                    );

                return (
                    date.getMonth() ===
                        lastMonth &&
                    date.getFullYear() ===
                        lastMonthYear
                );
            }
        ).length;

    const referralTrend =
        lastMonthReferrals > 0
            ? (
                  ((currentMonthReferrals -
                      lastMonthReferrals) /
                      lastMonthReferrals) *
                  100
              ).toFixed(1)
            : 0;

    return (
        <SimpleGrid
            columns={{
                base: 1,
                sm: 2,
                xl: 4,
            }}
            gap={6}
            mb={8}
        >
            <StatCard
                title="Total Referrals"
                value={
                    totalReferrals
                }
                trend={`${
                    referralTrend >=
                    0
                        ? "+"
                        : ""
                }${referralTrend}%`}
                trendColor={
                    referralTrend >=
                    0
                        ? "green.600"
                        : "red.500"
                }
                subtitle="Compared to last month"
                icon={
                    <Users
                        size={22}
                        color="#2453FF"
                    />
                }
            />

            <StatCard
                title="Active Drivers"
                value={
                    activeDrivers
                }
                trend={`${conversionRate}%`}
                trendColor="green.600"
                subtitle="Approved and active referrals"
                icon={
                    <Truck
                        size={22}
                        color="#0F766E"
                    />
                }
            />

            <StatCard
                title="Conversion Rate"
                value={`${conversionRate}%`}
                trend={`${activeDrivers}/${totalReferrals}`}
                trendColor="blue.600"
                subtitle="Registration to approval"
                icon={
                    <TrendingUp
                        size={22}
                        color="#2453FF"
                    />
                }
            />

            <StatCard
                title="Retention"
                value={`${retentionRate}%`}
                trend={`${firstDeliveryDrivers} retained`}
                trendColor="green.600"
                subtitle="Reached first delivery milestone"
                icon={
                    <RefreshCcw
                        size={22}
                        color="#6B7280"
                    />
                }
            />
        </SimpleGrid>
    );
};

export default AnalyticsStats;